'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createBreakpoints = {};

exports.__exports = createBreakpoints;
